import React, { useEffect, useState } from 'react'
import "../../css/PaymentHistory.css"
import { IoSearch } from "react-icons/io5";
import VectorHistory from "../../images/PaymentHistory/VectorHistory.png"
import Footer from '../CommonComponet/Footer';
import Header from '../CommonComponet/Header';
import { UserPaymentHistory } from '../../api/Api';
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useAuth } from '../../middleware/AuthProvider';
import FooterMobile from '../CommonComponet/FooterMobile';
import { Helmet } from 'react-helmet';

const PaymentHistory = () => {

    const { siteSetting } = useAuth();
    const [search, setSearch] = useState('')
    const [paymentData, setPaymentData] = useState([]);
    const [filtereddata, setFilteredData] = useState([]);
    const [cardSkeleton, setCardSkeleton] = useState(true);

    useEffect(() => {
        handleInputChange();
    }, [search]);

    useEffect(() => {
        PaymentHistoryApi();
        document.title = "Payment History Page On Hukup Australia"

    }, []);

    const handleInputChange = () => {
        const searchTerms = search.toLowerCase().split(' ');
        const filteredResult = paymentData.filter((ele) => {
            return searchTerms.every(term => (
                ele.paymentId.toString().toLowerCase().includes(term) ||
                ele.date.toString().toLowerCase().includes(term) ||
                ele.price.toString().toLowerCase().includes(term)
            ));
        });
        setFilteredData(filteredResult);
    };

    const PaymentHistoryApi = () => {
        UserPaymentHistory()
            .then(function (response) {
                setPaymentData(response.data.data)
                setFilteredData(response.data.data)
                setCardSkeleton(false)
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    return (
        <>
            <Helmet>
                <meta name="description" content={"Payment History Page On Hukup Australia"} />
            </Helmet>
            <div className="container-fluid p-0 main_section">
                <div className="background_section_main">
                    <img alt="orangeline" src={require("../../../src/images/orangeline.png")} className="d-none d-sm-none d-md-none d-lg-block footer_orangeline" />
                    <img alt="greenline" src={require("../../../src/images/greenline.png")} className="d-none d-sm-none d-md-none d-lg-block footer_greenline" />
                    <img alt="Ellipse" src={require("../../../src/images/Ellipse.png")} className="footer_ellipse_img" />
                    <img alt="footerblackline" src={require("../../../src/images/footerblackline.png")} className="footer_blackline_img" />
                </div>
                <Header />

                <div className="container-fluid content_main px-0">
                    <div className="Payment_History_main_section" >
                        <div className="container Payment_History_sticky_first_section" >
                            <div className="row my-3 my-sm-3 my-md-5 my-lg-4 my-xl-4">
                                <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 text-center text-sm-center text-md-end text-lg-end text-xl-end my-auto px-0  ">
                                    <h1 className="mr-0 mr-sm-5 mr-md-0 mr-lg-5 mr-xl-5 Payment_History_Title">Payment History</h1>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center my-auto px-0">
                                    <div class="search_main_section">
                                        <IoSearch className="search_icon" />
                                        <input type="text"
                                            value={search}
                                            onChange={(event) => setSearch(event.target.value)}
                                            className="form-control payment_history_searchbar" placeholder="Search..." />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container Payment_History_sticky_second_section">
                            <div className="row mt-0 mt-md-4 mt-lg-0">
                                {cardSkeleton && (
                                    <SkeletonTheme >
                                        <div className='px-3'>
                                            <Skeleton height={50} count={10} className='mb-2' />
                                        </div>
                                    </SkeletonTheme>
                                )}
                                {
                                    filtereddata.map((item) => {
                                        return (
                                            <div className="col-12 my-2">
                                                <div className="history_detail_row">
                                                    <div className="history_detail_icon">
                                                        <img alt='Premium' src={VectorHistory} />
                                                    </div>
                                                    <div className="history_detail_section">
                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-12 col-md-7 col-lg-6 col-xl-6 text-start text-sm-start text-md-center text-lg-center text-xl-center">
                                                                    <span className="history_detail_id my-auto" >{item.paymentId}</span>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-6 d-flex justify-content-between justify-content-sm-between  justify-content-md-evenly justify-content-lg-evenly justify-content-xl-evenly">
                                                                    <span className="history_detail_date my-auto">{item.date}</span>
                                                                    <span className="history_detail_price my-auto">{siteSetting?.paymentSetting?.symbol}{item.price}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <FooterMobile />
                </div>

            </div>
            <Footer />
        </>
    )
}

export default PaymentHistory